import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import Login from './Login';
import Register from './Register';
import Home from './Home';
import NewProject from './Wps_Stp_App';
import ExistingProjects from './ExistingProjects';
import ApprovalPage from './ApprovalPage';

export default function App() {
  const { currentUser } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={!currentUser ? <Login /> : <Navigate to="/" replace />} />
      <Route path="/register" element={!currentUser ? <Register /> : <Navigate to="/" replace />} />

      <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/new-project" element={<ProtectedRoute><NewProject /></ProtectedRoute>} />
      <Route path="/existing-projects" element={<ProtectedRoute><ExistingProjects /></ProtectedRoute>} />

      {/* Approval page - no auth required (approvers access via email link) */}
      <Route path="/approval/:token" element={<ApprovalPage />} />
    </Routes>
  );
}
